import {setupURLPolyfill} from './index';

setupURLPolyfill();
